import { appDomain } from "../AppDomain";
import { AppRoutes } from "../navigation/AppRoutes";
import { EnumUserRole } from "../users/EnumUserRole";
import { IMenuItem } from "./IMenuItem";
import { IRequestMenuItems } from "./IRequestMenuItems";

export class MenuService implements IRequestMenuItems {
    navigate(url: string) {
        appDomain.INavigator.navigateTo(url);
    }

    getAll(): IMenuItem[] {
        const menuitems: IMenuItem[] = [{
            name: "menu.day",
            icon: "fas fa-globe-americas",
            click: () => this.navigate(AppRoutes.day),
            routeName: AppRoutes.day
        }, {
            name: "menu.daybhv",
            icon: "fas fa-globe-americas",
            click: () => this.navigate(AppRoutes.bhvDay),
            routeName: AppRoutes.bhvDay
        }, {
            name: "menu.month",
            icon: "fas fa-globe-americas",
            click: () => this.navigate(AppRoutes.month),
            routeName: AppRoutes.month
        }
        ];

        if (appDomain.IAuthenticationService.getUserRole() === EnumUserRole.Administrator) {
            menuitems.push({
                name: "menu.attentiondays",
                icon: "fas fa-globe-americas",
                click: () => this.navigate(AppRoutes.attentiondays),
                routeName: AppRoutes.attentiondays
            });
        }

        if (appDomain.IAuthenticationService.getUserRole() === EnumUserRole.Administrator) {
            menuitems.push({
                name: "menu.employeegroups",
                icon: "fas fa-globe-americas",
                click: () => this.navigate(AppRoutes.employeegroups),
                routeName: AppRoutes.employeegroups
            });
        }

        const addLogout = true;
        if (addLogout) {
            menuitems.push({
                name: "menu.logout",
                icon: "",
                click: () => appDomain.IAuthenticationService.logout(),
                routeName: "logout"
            });
        }

        return menuitems;
    }
}
